import { render, staticRenderFns } from "./u-btn-icon-flat-circle.vue?vue&type=template&id=64a3f9dc&scoped=true&"
import script from "./u-btn-icon-flat-circle.vue?vue&type=script&lang=js&"
export * from "./u-btn-icon-flat-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a3f9dc",
  null
  
)

export default component.exports